// extracted by mini-css-extract-plugin
export default {"taskBox":"task-components_taskBox__BPsLU"};